export default function BuilderComponentsPanel() {
  return (
    <div className="h-full flex flex-col">
      <div className="px-3 py-2 text-xs tracking-wide text-purple-300/70">
        COMPONENTS
      </div>
      <div className="h-px bg-white/10 mx-3 mb-2" />

      <div className="flex-1 px-3 space-y-2 text-sm text-purple-100/80">
        <div className="rounded-md px-2 py-1 bg-white/5 hover:bg-white/10 cursor-pointer">
          Number Input
        </div>
        <div className="rounded-md px-2 py-1 bg-white/5 hover:bg-white/10 cursor-pointer">
          Text Input
        </div>
        <div className="rounded-md px-2 py-1 bg-white/5 hover:bg-white/10 cursor-pointer">
          Dropdown
        </div>
        <div className="rounded-md px-2 py-1 bg-white/5 hover:bg-white/10 cursor-pointer">
          Checkbox
        </div>
        <div className="rounded-md px-2 py-1 bg-white/5 hover:bg-white/10 cursor-pointer">
          Calculate Button
        </div>
      </div>
    </div>
  );
}
